import React, { Component } from 'react';
import {Select, Drawer, DatePicker, Table, Menu, Dropdown, Modal, TimePicker, message} from "antd";
import moment from 'moment-timezone';
import Moment from 'moment';
import { format,parseISO } from 'date-fns'
import {orderBy} from 'lodash';
import * as yup from "yup";
import { map } from 'lodash';
import _ from 'lodash';
import axios from "../../../../Lib/axios";
import { CSVLink } from "react-csv";
import { CodeFilled, DownOutlined } from "@ant-design/icons";

import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import DataTable from "../Component/Datatable";
import {FilterOutlined} from '@ant-design/icons';
import Loader from "../../../Common/Component/Loader";
import {errorHandle} from "../../../Common/errorHandle";
import workOrderStatus from '../../../Common/workOrderStatus.json';
import StatusOutsideAlerter from '../../../Common/serviceOutsideAlerter';
import chevronDown from "../../../../Assets/images/chevron-down.png";
import { formatToCurrency } from '../../../../Tools/formatToCurrency';

const {Option} = Select;
const { RangePicker } = DatePicker;

const workorder_status = [
  "tentative",
  "scheduled",
  "technician_assigned",
  "technician_en_route",
  "in_progress",
  "complete",
]
const time_status = [
  "tentative",
  "scheduled",
  "technician_assigned",
  "technician_en_route",
  "in_progress",
  "complete",
  "incomplete"
]
const DAY = {
  1:'Monday',
  2:'Tuesday',
  3:'Wednesday',
  4:'Thursday',
  5:'Friday',
  6:'Saturday',
  0:'Sunday'
}

var cond = "other";
class ViewByWorkOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myId: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
      customerList: {},
      franchiseList: {},
      leadList: {},
      customerListPagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
      activePagination: '15',
      leadListPagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
      activeLeadPagination: '15',
      filterData: {
        franchise: '',
        active: false,
        inactive: false,
        filterFranchise: '',
        joined: [],
        lastService: [],
        outstanding: 'all',
        satisfaction: ''
      },
      filterLeadData: {
        franchise: '',
        active: false,
        inactive: false,
        filterFranchise: '',
        lead_stage: 'all',
        outreach: 'all',
        first_contacted: [],
        last_contacted: []
      },
      openDrawer: false,
      openLeadDrawer: false,
      loader: false,
      search_value: '',
      lead_search_value: '',
      showAddLeadDrawer: false,
      errors: {},
      is_customer_filter:false,
      logged_in_user_role: [],
      current_tab: 1,
      customerType:[
        {
          "id": 0,
          "label": "All",
          "value": "all",
        },
        {
          "id": 1,
          "label": "Residential",
          "value": "residential",
        },
        {
          "id": 2,
          "label": "Commercial",
          "value": "commercial",
        }],
      is_modal_visible: false,
      selected_work_order:0,
      technicians:[],
      selected_row_keys: [],
      selected_work_order_status:'',
      selectedTechnician:'',
      selectedFranchise: '',
      selected_date: moment(),
      selected_time:'',
      workOrderList:{},
      filterCustomerType:[],
      filterTechnician:[],
      filterWorkOrderStatus:[],
      dateType:'',
      filterdate:'',
      startDate: null,
      endDate:null,
      toggleStatusFilter: false, 
      offset:0,
      limit:'15',
      ordering:'',
      headers : [
        { label: "Work Order", key: "work_order" },
        { label: "Status", key: "wo_status" },
        {label:"Day",key:'day'},
        { label: "Date", key: "dateCell" },
        { label: "Optimo Completed", key: "optimo_completed" },
        { label: "Optimo Sent", key: "optimo_sent" },
        { label: "Technician", key: "technician" },
        { label: "Customer Type", key: "customer_type" },
        { label: "Service Frequency", key: "service_frequency" },
        { label: "Customer", key: "customer" },
        { label: "Address", key: "address" },
        { label: "Zip Code", key: "zip_code" },
        { label: "City", key: "city" },
        { label: "Amount", key: "amount" },
      ],
      data : [],
      current:1,
      readOnlySearch:false,
      condOne:"no"
    }
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.tab;
    const {
      offset,
      limit,
      endDate,
      ordering,
      startDate,
      search_value,
      filterTechnician,
      filterCustomerType,
      filterWorkOrderStatus,
    } = this.state;
   
    if (id) {
      this.setState({ current_tab:0 });
    }
    this.setState({loader: true});
    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name);
    const selectedFranchise = authUser?.user?.associated_field_offices[0].uuid;

    this.setState({logged_in_user_role, selectedFranchise}, () => {
      this.callApi();

      const obj = {
        offset: offset,
        limit: limit,
        ordering: ordering,
        service_order__field_office__uuid: selectedFranchise,
        service_order__service_type__in:filterCustomerType.join(","),
        status__in:filterWorkOrderStatus.join(","),
        technician__uuid__in:filterTechnician.join(","),
        scheduled_time__range: startDate !== null ? `${moment(startDate).format('YYYY-MM-DD 00:00:01')},${moment(endDate).format('YYYY-MM-DD 23:59:59')}` : null,
        q:search_value
      };

      this.props.getViewByWorkOrder(obj);
      this.closeDrawer();
    });

    if(authUser?.user.role[0] === "franchise_owner")
    {
      this.props.getFranchise({uuid: authUser?.user?.associated_field_offices?.[0]?.uuid}); // Get franchise info
      this.props.getFieldOfficeStaff({field_office__uuid: authUser?.user?.associated_field_offices?.[0]?.uuid});
    }
    else{
      this.props.getFranchise(); // Get franchise list
      this.props.getFieldOfficeStaff();
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {customerList,
      franchiseList,
      leadList,
      workOrderList,
      logged_in_user_role,
      selectedFranchise
    } = this.state;
    this.setState({loader: false});

    ///////////////// Errors ////////////////////////////////
    if (nextProps?.residentialError && Object.keys(nextProps?.residentialError).length > 0 && nextProps?.residentialError !== this.props?.residentialError) {
      this.setState({loader: false});
      errorHandle(nextProps?.residentialError)
    }

    if (nextProps?.settingError && Object.keys(nextProps?.settingError).length > 0 && nextProps?.settingError !== this.props?.settingError) {
      this.setState({loader: false});
      errorHandle(nextProps?.settingError)
    }

    ///////////////////////////////////////////////////////////////////////

    //get Staff List
    if (Object.keys(nextProps.FieldStaff.data).length > 0 && nextProps.FieldStaff.data !== this.props.FieldStaff.data) {
      this.setState({
        loader: false,
        technicians: nextProps.FieldStaff.data.results
      })
    }

    // get customer list
    if (Object.keys(nextProps?.customerList).length > 0 && JSON.stringify(nextProps?.customerList) !== JSON.stringify(customerList)) {
      this.setState({customerList: nextProps?.customerList});
    }

    // get franchise list
    if (Object.keys(nextProps?.franchiseData).length > 0 && JSON.stringify(nextProps?.franchiseData) !== JSON.stringify(franchiseList)) {
      if(logged_in_user_role?.includes('franchise_owner'))
      {
        const franchise = nextProps?.franchiseData?.results?.filter((franchise) => franchise.uuid === selectedFranchise);
        this.setState({franchiseList: franchise});
      }
      else
        this.setState({franchiseList: nextProps?.franchiseData.results});
    }

    // get Work Order list
    if (Object.keys(nextProps?.GetViewByWorkOrder).length > 0 && JSON.stringify(nextProps?.GetViewByWorkOrder) !== JSON.stringify(workOrderList)) {
      
      let data = [];

      map(nextProps?.GetViewByWorkOrder.data.results, record => {
        let woStatus = '';

        if (record?.status === 'cancelled' && !record?.bill_for_cancelization) {
          woStatus = "Cancelled Non Billable";
        } else if (record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated) {
          woStatus = "Cancelled Billable";
        } else if (record?.status === 'cancelled' && record?.is_auto_invoice_genrated) {
          woStatus = "Cancelled Billed";
        } else {
          woStatus = record.status;
        }

        let customerName = `${record?.customer?.first_name||'NA'} ${record?.customer?.last_name||''}`;

        data.push({
          dateCell: moment(record?.date).format("MM-DD-YYYY"),
          work_order: record?.work_order_number || "Not Created",
          wo_status: woStatus,
          day: record?.scheduled_time ? DAY[moment(record?.scheduled_time).day()]: '',
          optimo_completed: record?.service_allocation.length === 0 ? "No" : record?.service_allocation?.[0]?.is_completed && record?.service_allocation?.[0]?.service_end_by_tech_ts ? moment(record?.service_allocation?.[0]?.service_end_by_tech_ts).format("MM-DD-YYYY"): record?.service_allocation?.[0]?.is_completed === false ? "No" : "No",
          optimo_sent: record?.service_allocation.length > 0 ? "Yes - " + moment(record?.service_allocation?.[0]?.created_at).format("MM-DD-YYYY"):"No",
          technician: record?.technician?.user?.first_name || 'NA',customer_type:record?.service_order?.service_type,service_frequency : record?.frequency,
          customer: customerName,address : record?.service_order?.service_address?.formatted_address,
          zip_code: record?.service_order?.service_address?.zip_code,
          city: record?.service_order?.service_address?.city,
          amount: "$" + parseFloat(record?.total_price).toFixed(2)
        });
      });

      this.setState({
        data:data,
        loader: false,
        readOnlySearch:false,
        workOrderList: nextProps?.GetViewByWorkOrder.data
      });
    }

    // get lead list
    if (Object.keys(nextProps?.Lead?.leadList).length > 0 && JSON.stringify(nextProps?.Lead?.leadList) !== JSON.stringify(leadList)) {
      this.setState({leadList: nextProps?.Lead?.leadList});
    }    
  }


  // get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;

    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner');
    const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese');
    const is_ope_mgr_franchise = logged_in_user_role?.includes('operations_mgr');
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese');
    const franchise_uuid = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    return {
      is_franchise_owner,
      franchise_uuid: franchise_uuid?.[0],
      is_disable_franchise_dropdown: (is_franchise_owner || is_ope_mgr_franchise || is_account_franchise || is_buss_dev_franchise)
    }
  }

  onSearchValue = (e) =>{
    this.setState({search_value: e.target.value})
  }

  onSearch = (e) => {
    this.setState({search_value: e.target.value}, () => {
      this.setState({loader:true})
      const {search_value} = this.state;
      if (search_value?.length === 1) {
        this.setState({
          readOnlySearch:true
        })
      }
      if(search_value?.length === 0  && this.state.selectedFranchise === '' 
        && this.state.startDate===null && this.state.filterCustomerType.length === 0 
        && this.state.filterTechnician.length === 0 && this.state.filterWorkOrderStatus.length===0)
      {
        setTimeout(() => this.setState({
          workOrderList:[],
          loader:false,
          readOnlySearch:false
        }), 1500);
      }else{
        setTimeout(() => this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,search_value,
          this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,
          this.state.filterTechnician,this.state.startDate,this.state.endDate) , 1000);
      }
    });
  };

  // On switch tab
  switchTab = (value) => {
    this.setState({current_tab: value}, () => {this.callApi()});
  };

  callApi = () => {
    const {activePagination, activeLeadPagination, current_tab, search_value} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    this.setState({loader: true});
    if (current_tab === 1) {
      // Get list of customers
      this.setState({
        filterData: {
          active: false,
          inactive: false,
          franchise: '',
          joined: [],
          lastService: [],
          outstanding: [],
          satisfaction: ''
        }}, () => this.props.getCustomers({
        limit: activePagination,
        offset: 0,
        q: search_value,
        serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
        ordering: '-created_at',
        is_active: true 
      })
      )
    } else if (current_tab === 0) {
      this.props.getLeads({limit: activeLeadPagination,
        offset: 0,
        q: search_value,
        serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
        is_active : true
      }); // Get list of leads
    } else if (current_tab === 2) {
      this.setState({
        filterData: {
          active: false,
          inactive: false,
          franchise: '',
          joined: [],
          lastService: [],
          outstanding: [],
          satisfaction: ''
        }}, () => this.props.getCustomers({
        limit: activePagination,
        offset: 0,
        q: search_value,
        serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
        ordering: '-created_at',
        is_active: false
      })
      );
    }
  }

  // toggle add leader drawer
  toggleAddLeadDrawer = (value) => {
    this.setState({showAddLeadDrawer: value})
  };

  // add zero before number
  leadingZeros = (value, size) => {
    let s = String(value);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  ////////////////////////////////////////// Customer /////////////////////////////
  // filter data change
  onFilterChange = (e, type, name) => {
    const {filterData} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(filterData, {[e.target.name]: value});
    this.setState({filterData}, () => {
      if (name === 'franchise') {
        this.onFilterClick()
      }
    });
  };
  
  onCustomerTypeChanged = (e, index) => {
    const { filterCustomerType,customerType } = this.state;
    let arrStatus = [...filterCustomerType];
    if (e?.target?.checked) {
      if (index === 0) {
        customerType.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1) {
            arrStatus.push(element.value)
          }          
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          customerType[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }      
    } else {
      if (index === 0) {
        customerType.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          customerType[0]['is_change'] = false;
          customerType[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }      
    }
    
    this.setState({ filterCustomerType: arrStatus },() => {
      // this.setState({ toggleCustomerTypeFilter: false })
      // this.onFilter(arrStatus.join(), "filterWorkOrderStatus");
    });    
  }
  
  onTechnicianChanged = (e, index) => {
    const { filterTechnician,technicians } = this.state;
    let arrStatus = [...filterTechnician];
    if (e?.target?.checked) {
      if (index === "aa") {
        technicians.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.uuid) === -1) {
            arrStatus.push(element.uuid)
          }          
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          technicians[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }      
    } else {
      if (index === 'aa') {
        technicians.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          // technicians[0]['is_change'] = false;
          technicians[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }      
    }
    this.setState({ filterTechnician : arrStatus },() => {
      // this.setState({ toggleTechnicianFilter : false })
      // this.onFilter(arrStatus.join(), "filterWorkOrderStatus");
    });    
  }

  onStatusChanged = (e, index) => {
    const { filterWorkOrderStatus } = this.state;
    let arrStatus = [...filterWorkOrderStatus];
    if (e?.target?.checked) {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1) {
            arrStatus.push(element.value)
          }          
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          workOrderStatus.WorkOrderStatus[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }      
    } else {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          workOrderStatus.WorkOrderStatus[0]['is_change'] = false;
          workOrderStatus.WorkOrderStatus[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }      
    }
    
    this.setState({ filterWorkOrderStatus: arrStatus },() => {
      // this.setState({ toggleStatusFilter: false })
      // this.onFilter(arrStatus.join(), "filterWorkOrderStatus");
    });    
  }

  closeStatusFilter = () => {
    this.setState({ toggleStatusFilter: false });
  }
  closeCustomerTypeFilter = () => {
    this.setState({ toggleCustomerTypeFilter: false });
  }
  closeTechnicianFilter = () => {
    this.setState({ toggleTechnicianFilter: false });
  }

  toggleStatus = () => {
    const { toggleStatusFilter } = this.state;

    if (toggleStatusFilter) {
      this.setState({ toggleStatusFilter: false });
    } else {
      this.setState({ toggleStatusFilter: true,toggleTechnicianFilter:false,toggleCustomerTypeFilter:false});
    }
  }

  toggleCustomerType = () => {
    const { toggleCustomerTypeFilter } = this.state;

    if (toggleCustomerTypeFilter) {
      this.setState({ toggleCustomerTypeFilter: false });
    } else {
      this.setState({ toggleCustomerTypeFilter: true,toggleTechnicianFilter:false,toggleStatusFilter:false});
    }
  }

  toggleTechnician = () => {
    const { toggleTechnicianFilter } = this.state;

    if (toggleTechnicianFilter) {
      this.setState({ toggleTechnicianFilter: false });
    } else {
      this.setState({ toggleTechnicianFilter: true,toggleCustomerTypeFilter:false,toggleStatusFilter:false});
    }
  }

  renderTechnicianFilters =  () => {
    const { toggleTechnicianFilter, filterTechnician,technicians } = this.state;
    return (
      <div className="image-input work-order-status view-by-work-order-status">
        <div className="fitem">
          <input 
            type="text" 
            style={{"background":"white", "padding": "5.5px 16px"}}
            id="txtStatus"
            value={filterTechnician.length === 0 ? 'Select Technician' : `Technician: ${filterTechnician.length} items selected`} 
            onClick={() => {this.toggleTechnician() }} 
          />
          <img 
            style={{"top": "0.5px"}}
            src={chevronDown}
            alt=""
            onClick={() => { this.toggleTechnician() }} 
          />
        </div>
        {toggleTechnicianFilter && <div style={{'position':'relative'}} className="field-dropdown right">
          <div className="field-dropdown-body">
            {
              map(technicians, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input
                      id={item.uuid}
                      type="checkbox"
                      checked={item.is_change}
                      className="fitem-ck-input"
                      onChange={ (e) => { this.onTechnicianChanged(e, index) } }
                    />
                    <label htmlFor={item.uuid} className="fitem-ck-txt">{`${item?.user?.first_name} ${item?.user?.last_name}`}</label>
                  </div>
                )
              })}
          </div>
        </div>}
      </div>)
  }

  renderCustomerTypeFilters =  () => {
    const { toggleCustomerTypeFilter, filterCustomerType } = this.state;
    return (
      <div className="image-input work-order-status view-by-work-order-status">
        <div className="fitem">
          <input 
            type="text" 
            style={{"background":"white", "padding": "5.5px 16px"}}
            id="txtStatus"
            value={filterCustomerType.length === 0 ? 'Select Customer Type' : `Customer Type: ${filterCustomerType.length} items selected`} 
            onClick={() => {this.toggleCustomerType() }} 
          />
          <img 
            style={{"top": "0.5px"}}
            src={chevronDown}
            alt=""
            onClick={() => { this.toggleCustomerType() }} 
          />
        </div>
        {toggleCustomerTypeFilter && <div style={{'position':'relative'}} className="field-dropdown right">
          <div className="field-dropdown-body">
            {
              map(this.state.customerType, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input
                      id={item.value}
                      type="checkbox"
                      checked={item.is_change}
                      className="fitem-ck-input"
                      onChange={ (e) => { this.onCustomerTypeChanged(e, index) } }
                    />
                    <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                  </div>
                )
              })}
          </div>
        </div>}
      </div>)
  }

  renderStatusFilters =  () => {
    const { toggleStatusFilter, filterWorkOrderStatus } = this.state;
    return (
      <div className="image-input work-order-status view-by-work-order-status">
        <div className="fitem">
          <input 
            type="text" 
            style={{"background":"white", "padding": "5.5px 16px"}}
            id="txtStatus"
            value={filterWorkOrderStatus.length === 0 ? 'Select Status' : `Status: ${filterWorkOrderStatus.length} items selected`} 
            onClick={() => {this.toggleStatus() }} 
          />
          <img 
            style={{"top": "0.5px"}}
            src={chevronDown}
            alt=""
            onClick={() => { this.toggleStatus() }} 
          />
        </div>
        {toggleStatusFilter && <div style={{'position':'relative'}} className="field-dropdown right">
          <div className="field-dropdown-body">
            {
              map(workOrderStatus.WorkOrderStatus, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input
                      id={item.value}
                      type="checkbox"
                      checked={item.is_change}
                      className="fitem-ck-input"
                      onChange={ (e) => { this.onStatusChanged(e, index) } }
                    />
                    <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                  </div>
                )
              })}
          </div>
        </div>}
      </div>)
  }

  handelEditStatus =(e,record)=>{
    let selected_row_keys = [];
    let cond1="";
    if(record.status==="forecast"){
      cond1="yes"
    }else{
      cond1="no"
    }
    selected_row_keys.push(record)
    let status = record?.status
    if(record?.status === 'cancelled' && !record?.bill_for_cancelization){
      status = 'cancelled_non_billable';
    }
    if(record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated){
      status = 'cancelled_billable'
    }
    this.setState({
      is_modal_visible:true,
      selected_row_keys:selected_row_keys,
      condOne:cond1,
      selected_date: moment(record?.scheduled_time),
      selected_work_order_status:status,
      selected_time:record?.time,
      selectedTechnician:record?.technician?.uuid
    });
  }

    // Render table action menu
    renderAction = (record) => {
      const menu = (
        <Menu>
          <Menu.Item key="1"             
            disabled={((record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true) && (record?.status === "complete" || record?.status === "cancelled" || record?.status === "scheduled")) || this.state.selected_row_keys.length>1}
          ><a onClick={(e) => this.handelEditStatus(e,record)}>Edit Status</a></Menu.Item>
          <Menu.Item key="2"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'work_order', record)}>Edit Work Order</a></Menu.Item>
          <Menu.Item key="3"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'service_order', record)}>Edit Service Order</a></Menu.Item>
        </Menu>
      )
  
      return (
        <Dropdown overlay={menu} trigger={['hover']}>
          <span onClick={e => e.preventDefault()}>
            <DownOutlined />
          </span>
        </Dropdown>
      )
    }

  onFilterWorkOrder = (selectedFranchise,ordering,search_value,offset,limit,filterCustomerType,filterWorkOrderStatus,filterTechnician,startDate,endDate) =>{
    const {filters,filterData} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
    const obj = {
      offset: offset,
      limit: limit,
      ordering: ordering,
      service_order__field_office__uuid: selectedFranchise === 'all' ? '' : selectedFranchise,
      service_order__service_type__in:filterCustomerType.join(","),
      status__in:filterWorkOrderStatus.join(","),
      technician__uuid__in:filterTechnician.join(","),
      scheduled_time__range: startDate!==null?`${moment(startDate).format('YYYY-MM-DD 00:00:01')},${moment(endDate).format('YYYY-MM-DD 23:59:59')}`:null,
      q:search_value
    };

    if (filters?.franchise || (filterData?.franchise && filterData?.franchise !== 'all')) {
      Object.assign(obj, {franchise: filters?.franchise?.toString() || filterData?.franchise});
    }
    this.props.getViewByWorkOrder(obj);
    this.closeDrawer();
    this.setState({loader: true});
  }

  //clear filter
  onClearFilter = () => {
    if(this.state.selectedFranchise === '' && this.state.startDate === null && this.state.search_value?.length === 0){
      this.onCustomerTypeChanged(0, 0);
      this.onStatusChanged(0,0);
      this.onTechnicianChanged(0,'aa');
      this.setState({
        filterCustomerType:[],
        filterTechnician:[],
        filterWorkOrderStatus:[]
      }, () => {
        setTimeout(() =>this.setState({workOrderList:[]},this.closeDrawer()) , 1000)
      });  
    }else{
      this.onCustomerTypeChanged(0, 0);
      this.onStatusChanged(0,0);
      this.onTechnicianChanged(0,'aa');
      this.setState({
        filterCustomerType:[],
        filterTechnician:[],
        filterWorkOrderStatus:[]
      }, () => {
        setTimeout(() =>this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,this.state.search_value,this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,this.state.startDate,this.state.endDate) , 1000)
      });
    }
  };

  // close customer filter drawer
  closeDrawer = () => {
    this.setState({openDrawer: false,toggleStatusFilter: false,toggleTechnicianFilter:false,toggleCustomerTypeFilter:false});
  };

  //Table Order and Pagination
  onCustomerTableChange = (pagination, filters, sorter) => {
    let ordering = this.state.ordering
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }
    this.setState({
      ordering,
      current: pagination.current
    })
    this.onFilterWorkOrder(this.state.selectedFranchise,ordering,this.state.search_value,((pagination.current - 1) * this.state.limit),pagination?.pageSize,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,this.state.startDate,this.state.endDate)
  }

  // page size change
  setCustomerPageLimit = (value) => {
    this.setState({limit:value})
    this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,this.state.search_value,this.state.offset,value,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,this.state.startDate,this.state.endDate)
  };


  ////////////////////////////// Lead ///////////////////////////
  // Lead filter data change
  onLeadFilterChange = (e, type, name) => {
    const {filterLeadData} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(filterLeadData, {[e.target.name]: value});
    if (e.target.name === 'inactive') Object.assign(filterLeadData, {lead_stage: 'all'})
    this.setState({filterLeadData}, () => {
      if (name === 'franchise') {
        this.onLeadFilterClick()
      }
    });
  };

  // on Lead filter click
  onLeadFilterClick = () => {
    const {filterLeadData, activeLeadPagination, leadListPagination} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();
    this.setState({loader: true, lead_search_value: ''});
    const obj = {
      offset: 0,
      limit: activeLeadPagination,
      ordering: '',
      serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : ''
    };

    if (filterLeadData?.franchise && filterLeadData?.franchise !== 'all') {
      Object.assign(obj, {serviceorder__field_office__uuid: filterLeadData?.franchise});
    }

    if ((filterLeadData?.active && !filterLeadData?.inactive) || (!filterLeadData?.active && filterLeadData?.inactive)) {
      Object.assign(obj, {is_active: filterLeadData?.active === true ? true : filterLeadData?.inactive === true && false});
    }

    if (filterLeadData?.lead_stage && filterLeadData?.lead_stage !== 'all') {
      Object.assign(obj, {lead_profile__stage: filterLeadData?.lead_stage})
    }

    if (filterLeadData?.outreach && filterLeadData?.outreach !== 'all') {
      Object.assign(obj, {lead_profile__outreach: filterLeadData?.outreach})
    }

    if (filterLeadData?.last_contacted?.length > 0) {
      Object.assign(obj, {lead_status_logs__created_at__range: `${moment(filterLeadData?.last_contacted?.[0]).format('YYYY-MM-DDT00:00:00')}, ${moment(filterLeadData?.last_contacted?.[1]).format('YYYY-MM-DDT23:59:59')}`})
    }

    this.props.getLeads(obj);
    this.setState({leadListPagination: {...leadListPagination, current: 1}})
    this.closeLeadDrawer();
  };

  //clear lead filter
  onClearLeadFilter = () => {
    this.setState({
      filterLeadData: {
        active: false,
        inactive: false,
        franchise: '',
        lead_stage: 'all',
        outreach: 'all',
        first_contacted: [],
        last_contacted: []
      }
    }, () => {
      setTimeout(() => this.onLeadFilterClick(), 1500)
    });
  };

  // close lead filter drawer
  closeLeadDrawer = () => {
    this.setState({openLeadDrawer: false});
  };

  // Leads Table Order and Pagination
  onLeadTableChange = (pagination, filters, sorter) => {
    const {leadListPagination, activeLeadPagination, filterLeadData, search_value} = this.state;
    let ordering = ''
    Object.assign(leadListPagination, { current: pagination.current });
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }

    this.setState({
      leadListPagination,
      loader: true,
    });

    let obj = { offset: ((pagination.current - 1) * activeLeadPagination), limit: pagination?.pageSize, ordering,
      serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '', q: search_value }
    if (filterLeadData?.franchise && filterLeadData?.franchise !== 'all') {
      Object.assign(obj, {serviceorder__field_office__uuid: filterLeadData?.franchise});
    }

    if ((filterLeadData?.active && !filterLeadData?.inactive) || (!filterLeadData?.active && filterLeadData?.inactive)) {
      Object.assign(obj, {is_active: filterLeadData?.active === true ? true : filterLeadData?.inactive === true && false});
    }

    if (filterLeadData?.lead_stage && filterLeadData?.lead_stage !== 'all') {
      Object.assign(obj, {lead_profile__stage: filterLeadData?.lead_stage})
    }

    if (filterLeadData?.outreach && filterLeadData?.outreach !== 'all') {
      Object.assign(obj, {lead_profile__outreach: filterLeadData?.outreach})
    }

    if (filterLeadData?.last_contacted?.length > 0) {
      Object.assign(obj, {lead_status_logs__created_at__range: `${moment(filterLeadData?.last_contacted?.[0]).format('YYYY-MM-DDThh:mm:ss')}, ${moment(filterLeadData?.last_contacted?.[1]).format('YYYY-MM-DDThh:mm:ss')}`})
    }

    this.props.getLeads(obj);
  }

  // leads page size change
  setLeadPageLimit = (value) => {
    const {leadListPagination, filterLeadData, search_value} = this.state;
    Object.assign(leadListPagination, { current: 1, pageSize: value, ordering: '', q: search_value });
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    this.setState({activeLeadPagination: value, leadListPagination});
    let obj = { offset: 0, limit: value, ordering: '', serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : ''}
    if (filterLeadData?.franchise && filterLeadData?.franchise !== 'all') {
      Object.assign(obj, {serviceorder__field_office__uuid: filterLeadData?.franchise});
    }

    if ((filterLeadData?.active && !filterLeadData?.inactive) || (!filterLeadData?.active && filterLeadData?.inactive)) {
      Object.assign(obj, {is_active: filterLeadData?.active === true ? true : filterLeadData?.inactive === true && false});
    }

    if (filterLeadData?.lead_stage && filterLeadData?.lead_stage !== 'all') {
      Object.assign(obj, {lead_profile__stage: filterLeadData?.lead_stage})
    }

    if (filterLeadData?.outreach && filterLeadData?.outreach !== 'all') {
      Object.assign(obj, {lead_profile__outreach: filterLeadData?.outreach})
    }

    if (filterLeadData?.last_contacted?.length > 0) {
      Object.assign(obj, {lead_status_logs__created_at__range: `${moment(filterLeadData?.last_contacted?.[0]).format('YYYY-MM-DDThh:mm:ss')}, ${moment(filterLeadData?.last_contacted?.[1]).format('YYYY-MM-DDThh:mm:ss')}`})
    }

    this.props.getLeads(obj);
  };


  // render customer filter drawer
  renderDrawer = () => {
    const {
      openDrawer,
    } = this.state;

    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={this.closeDrawer}
        visible={openDrawer}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="group_wrapper rdrawer">
          <div className="card-head">
            <h4>Filter Work Orders</h4>
          </div>
          <div className="card-row">
            <div className="card-full">
              <div className="form-group">
                <div className="fitem">
                  <label htmlFor="customerType">Customer Type</label>
                  {this.renderCustomerTypeFilters()}
                </div>
                <div className="fitem">
                  <label htmlFor="workOrderStatus">Work Order Status</label>
                  {this.renderStatusFilters()}
                </div>
                <div className="field-group">
                  <label>Technician</label>
                  {this.renderTechnicianFilters()}
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => {this.closeDrawer()}}>Cancel</button>
            <button className={`btn btn-warning`} onClick={() => {this.onClearFilter();}}>Clear</button>
            <button
              // type="submit"
              className={`btn btn-primary`}
              onClick={() => this.filter()}>   Filter WO
            </button>
          </div>
        </div>
      </Drawer>
    )
  };

  filter = () =>{
    this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,this.state.search_value,this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,this.state.startDate,this.state.endDate);
    this.setState({current:1,toggleStatusFilter: false,toggleTechnicianFilter:false,toggleCustomerTypeFilter:false})
  }

  filterDate = (dateType) => {
    let startDate=null;
    let endDate=null;
    if(dateType==='Yesterday'){
      startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
      endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
    }
    if(dateType==='Today'){
      startDate = moment().format('YYYY-MM-DD');
      endDate = moment().format('YYYY-MM-DD');
    }
    if(dateType==='Tomorrow'){
      startDate = moment().add(1, 'days').format('YYYY-MM-DD');
      endDate = moment().add(1, 'days').format('YYYY-MM-DD');
    }
    if(dateType==='Last Week'){
      startDate = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
      endDate = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
    }
    if(dateType==='This Week'){
      startDate = moment().startOf('week').format('YYYY-MM-DD');
      endDate = moment().endOf('week').format('YYYY-MM-DD');
    }
    if(dateType==='Next Week'){
      startDate = moment().add(1, 'weeks').startOf('week').format('YYYY-MM-DD');
      endDate = moment().add(1, 'weeks').endOf('week').format('YYYY-MM-DD');
    }
    this.setState({
      dateType:dateType,
      startDate:startDate,
      endDate:endDate
    })
    this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,this.state.search_value,this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,startDate,endDate)
  }


  onActionChange = (event, action, row) => {
    event.preventDefault();
    switch(action)
    {
    case 'work_order':
      if (row?.customer) {
        if (row?.customer?.role[0] === 'customer') {
          this.props.history.push(`/residential/detail?redirect_to_work_order=true`, { query: { 
            id: row?.customer?.uuid, 
            selectedTab: 2,
            service: row.service_order,
            work_order_uuid: row.uuid,
            transection_type:"Update"
          }});
        } else if (row?.customer?.role[0] === 'commercial_customer') {
          this.props.history.push(`/commercial/customer-detail?redirect_to_work_order=true`, { query: {
            id: row?.customer?.uuid,
            selectedTab:  2,
            service: row.service_order,
            work_order_uuid: row.uuid,
            transection_type:"Edit"
          }})
        }
      }
      break;
    case 'service_order':
      if (row?.customer) {
        if (row?.customer?.role[0] === 'customer') {
          this.props.history.push(`/residential/detail?redirect_to_service=true`, { query: {
            id: row?.customer?.uuid, 
            selectedTab: 2,
            service: row.service_order,
            work_order_uuid: row.uuid
          }});
        } else if (row?.customer?.role[0] === 'commercial_customer') {
          this.props.history.push(`/commercial/customer-detail?redirect_to_service=true`, { query: { 
            id: row?.customer?.uuid,
            selectedTab: 2,
            service: row.service_order,
            work_order_uuid: row.uuid
          }});
        }
      }
    }
  }


    //Selct Table Row checkbox
    onSelectedRowKeysChange = (selectedRowKeys) => {
      if(selectedRowKeys.length===1){
        let record = this.state.workOrderList?.results?.filter(r => r.uuid === selectedRowKeys[0])[0]
        let status = record?.status
        if(record?.status === 'cancelled' && !record?.bill_for_cancelization){
          status = 'cancelled_non_billable';
        }
        if(record?.status === 'cancelled' && record?.bill_for_cancelization && !record?.is_auto_invoice_genrated){
          status = 'cancelled_billable'
        }
        this.setState({selected_date: moment(record?.scheduled_time), selected_work_order_status:status,selected_time:record?.time,selectedTechnician:record?.technician?.uuid
        })
      }else{
        this.setState({selected_date: moment() ,selected_work_order_status:'',selected_time:''})
      }
      
      this.setState({ selected_row_keys: selectedRowKeys });
    }



    // convert date time from local to utc
    localToUTC = (date) => {
      return moment.utc(date)
    }

  updateWorkOrder = () => {
    let arrData = [];
    map(this.state.selected_row_keys, x => {
      arrData.push({
        bill_for_cancelization:this.state.selected_work_order_status==='cancelled_non_billable'?false:this.state.selected_work_order_status==='cancelled_billable'?true:null,
        uuid: x.uuid?x.uuid:x,
        status: this.state.selected_work_order_status==='cancelled_non_billable' || this.state.selected_work_order_status==='cancelled_billable'?"cancelled":this.state.selected_work_order_status,
        date: this.state.selected_date ? this.state.selected_date.format('YYYY-MM-DD') : null,
        technician_uuid: this.state.selectedTechnician?this.state.selectedTechnician:'',
        time: moment(this.state?.selected_time).format("HH:mm:ss") === "Invalid date" ? this.state?.selected_time : moment(this.state?.selected_time).format("HH:mm:ss"),
      })
    })
    axios.post(`/service-ftech/batch_update_service_order/`, arrData).then((response) => {
      message.success(`Status of the respective work order(s) has been changed successfully`, 10);
      setTimeout(() => {
        this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,this.state.search_value,this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,this.state.startDate,this.state.endDate);
        this.setState({ is_modal_visible: false,selected_row_keys:[],selected_work_order_status:'',time:'',selectedTechnician:'',selected_date: moment().format('MM/DD/YYYY'),selected_time:'',errors:{}})
      }, 1000);
    }).catch(error => {
      message.error(`Error occurred while updating Work order.`, 100);
    });
  }

  setSelectedDateRange = (e) => {
    if(e){
      this.setState({
        startDate:moment(e[0]).format('YYYY-MM-DD'),
        endDate: moment(e[1]).format('YYYY-MM-DD'),
        dateType:''
      })
    } else{
      this.setState({
        startDate: null, //moment().subtract(1, 'years').format('YYYY-MM-DD'),
        endDate: null, //moment().format('YYYY-MM-DD')
        dateType:''
      })
    }
    this.onFilterWorkOrder(this.state.selectedFranchise,this.state.ordering,this.state.search_value,this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,this.state.filterTechnician,moment(e[0]).format('YYYY-MM-DD'),moment(e[1]).format('YYYY-MM-DD'))
    this.setState({current:1})
  }

  validate = () => {
    const {selected_time,selected_date,selected_work_order_status} = this.state;
    let selectedTime = moment(selected_time).format("hh:mm a") === "Invalid date" ? selected_time : moment(selected_time).format("hh:mm a");
    let selectedDate = selected_work_order_status === 'forecast' ? selected_date : `${selected_date} ${selectedTime}`;
    let isPastDate = false;
    let isFutureDate = false;
    if (selected_work_order_status === 'forecast') {
      isPastDate = moment(selected_date, "YYYY/MM/DD").isBefore(moment(new Date()).format("YYYY/MM/DD"));
      console.warn('forecast - isPastDate', isPastDate, 'scheduled', selectedDate)
    }
    if (selected_work_order_status === 'scheduled') {
      isPastDate = moment(selected_date).isBefore(moment(new Date()).format("YYYY/MM/DD hh:mm a"));
      console.warn('scheduled- isPastDate', isPastDate, 'scheduled', selected_date)
    }
    if (selected_work_order_status === 'complete' || selected_work_order_status === 'incomplete' ||  selected_work_order_status==='cancelled_billable') {
      isFutureDate = !moment(selected_date, "YYYY/MM/DD").isBefore(moment());
    }
    const schema = yup.object().shape({
      selected_date : yup.string().required('Select date.'),
      selected_work_order_status: yup.string().required('Please select valid status.'),
      selected_time: time_status.indexOf(selected_work_order_status) > -1 && !this.state?.time ? yup.string().required('Select time.') : null,
      time_past: isPastDate && (selected_time || selected_work_order_status === 'forecast') ? yup.string().required('Work orders in this status cannot have a date/time in the past.') : null,
      time_future: isFutureDate ? yup.string().required('Work orders in this status cannot have a date/time in the future.') : null,
      technician: workorder_status.indexOf(selected_work_order_status) > -1 && !this.state.selectedTechnician ? yup.string().required('Please select assigned technician.') : null,
    });
    const data = { selected_date: selected_date || '', selected_time, selected_work_order_status };
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState(s => ({ ...s, errors: {} }));
      this.updateWorkOrder();
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => { err_data[item.path] = item.message });
      console.log("error",err_data)
      this.setState(s => ({ ...s, errors: err_data }));
    })
  }
  
  
  //render Work Order list
  renderWorkOrderList = () => {
    const {
      workOrderList,
      customerListPagination,
      activePagination,
      search_value,
      current,
      selected_row_keys
    } = this.state;
    const franchise = workOrderList?.results?.map((item) => ({text: item?.name, value: item?.uuid}));
    cond="other";
    if(selected_row_keys.length>0){
      let arr = [];
      map(selected_row_keys,(sk,i) =>{
        let WO = workOrderList?.results.filter(function( obj ) { 
          return obj.uuid ===sk;
        });
        arr.push(WO[0])
      });
      let findArr = _.map(arr,'status')
      let isDisabled = findArr.includes("forecast");
      if(isDisabled){
        cond="yes"
      }else if(isDisabled===false){
        cond="no"
      }else{
        cond="other"
      }
    }
    return (
      <div className="leadstblviewbyworkorder">
        <Table
          rowKey={record => record.uuid}
          dataSource={workOrderList?.results}
          pagination={{showSizeChanger: false, pageSize: this.state.limit, current, total: workOrderList?.count}}
          columns={DataTable.customerColumns(this)}
          onChange={workOrderList?.results?.length > 0 ?this.onCustomerTableChange:null}
          onRow={this.onCustomerListRow}
          className="customer-list field_serve"
          rowSelection={{
            type:'checkbox',
            hideSelectAllCheckbox:true,
            preserveSelectedRowKeys: true,
            selectedRowKeys: selected_row_keys,
            onChange: (selected_row_keys) => {this.onSelectedRowKeysChange(selected_row_keys)},
            getCheckboxProps: (record) => {
              return {
                disabled: (cond==="yes"?((record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true) || (record?.status !== "forecast")):cond==="no"?((record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true) || (record?.status === "forecast")):(record?.is_auto_invoice_genrated===true || record?.is_manual_invoice_generated===true) && (record?.status === "scheduled" || record?.status === "complete" || record?.status === "cancelled")),
              }
            },
          }}
          footer={() => <ul className='view_work_order_total'><li>Total</li><li>{workOrderList?.results?.length > 0 ?'$':'$'}{formatToCurrency(workOrderList?.results?.reduce((a, b) => a + (b['total_price'] || 0), 0))}</li></ul>}
        />
        {workOrderList?.results?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setCustomerPageLimit('15') }}
                className={this.state.limit === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={this.state.limit === '30' ? 'active' : ''}
                onClick={() => { this.setCustomerPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={this.state.limit === '60' ? 'active' : ''}
                onClick={() => { this.setCustomerPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  };

  render() {
    const {
      filterData,
      franchiseList,
      current_tab,
      loader,
      search_value,
      showAddLeadDrawer,
      filterLeadData,
      is_modal_visible,
      selected_work_order,
      technicians,
      selected_work_order_status,
      selectedTechnician,
      selected_date,
      selected_time,
      selectedFranchise,
      errors,
      data
    } = this.state;
    const {is_disable_franchise_dropdown} = this.getLoggedInUserRole()

    return (
      <div id="wrapper abs">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder={'Customer Name or Zip Code'}
            search_value={search_value}
            onSearch={this.onSearch}
            disabled={this.state.readOnlySearch}
            // onEnter={(e) => e.target.value.length>2?this.setState({search_value: '', loader: true}, () => this.onSearch(e)):alert("Enter at least 3 character!")}
          />
          {/* Sidebar */}
          <Sidebar />

          <div className="container">
            {loader && <Loader/>}
            <div className="filter_wrapper">
              <div className="left_side">
                <div className="fitem">
                  <Select
                    className="swhite"
                    name="franchise"
                    value={selectedFranchise}
                    onChange={(e) => {
                      this.setState({ selectedFranchise: e, filterTechnician:[]});
                      this.props.getFieldOfficeStaff({field_office__uuid: e})
                      this.onFilterWorkOrder(e,this.state.ordering,this.state.search_value,this.state.offset,this.state.limit,this.state.filterCustomerType,this.state.filterWorkOrderStatus,[],this.state.startDate,this.state.endDate);
                      this.setState({current: 1})
                    }}
                  >
                    {
                      orderBy(franchiseList, 'id', 'asc')?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{`${this.leadingZeros(option?.id, 3)} ${option?.name}`}</Option>) 
                    }
                  </Select>
                </div>
                <div className='fitem' style={{padding:'0px 4px'}}>
                  <RangePicker
                    format={'MM/DD/YYYY'}
                    className="date_ranger dwhite"
                    dropdownClassName="dropdown_date_range"
                    prefixIcon={<i className="las la-calendar"></i>}
                    onChange={(e) => { this.setSelectedDateRange(e) }}
                    value={this.state.startDate!==null?[moment(this.state.startDate), moment(this.state.endDate)]:''}
                  />
                </div>
              </div>
              <ul className="tabs mwhite field-service d-block">
                <li className={this.state.dateType === 'Yesterday' ? 'active' : ''} onClick={() => { this.filterDate('Yesterday'); }}>
                  <span>{`Yesterday`}</span>
                </li>
                <li className={this.state.dateType === 'Today' ? 'active' : ''} onClick={() => { this.filterDate('Today'); }}>
                  <span>Today</span>
                </li>
                <li className={this.state.dateType === 'Tomorrow' ? 'active' : ''} onClick={() => { this.filterDate('Tomorrow'); }}>
                  <span>{`Tomorrow`}</span>
                </li>
              </ul>
              <ul className="tabs mwhite field-service d-block" style={{'marginLeft':'10px'}}>
                <li className={this.state.dateType === 'Last Week' ? 'active' : ''} onClick={() => { this.filterDate('Last Week'); }}>
                  <span>{`Last Week`}</span>
                </li>
                <li className={this.state.dateType === 'This Week' ? 'active' : ''} onClick={() => { this.filterDate('This Week'); }}>
                  <span>This Week</span>
                </li>
                <li className={this.state.dateType === 'Next Week' ? 'active' : ''} onClick={() => { this.filterDate('Next Week'); }}>
                  <span>{`Next Week`}</span>
                </li>
              </ul>
              <div className="right_side">
                <span className="ico-btn">
                  <FilterOutlined onClick={(e) => this.setState({openDrawer: true},e.stopPropagation(),e.preventDefault())}>Filter</FilterOutlined>
                </span>
                <CSVLink
                  headers={this.state.headers}
                  data={data}
                  filename="work_order.csv"
                  style={{'paddingRight':'10px'}}
                >
                  <button className="btn btn-primary btn-bdr flex mr-1">Export</button>
                </CSVLink>
                <button className="btn btn-primary btn-bdr flex" onClick={() => this.setState({is_modal_visible:true})}
                >Edit Status</button>
              </div>
            </div>
            <div className="data leadstable">
              {this.renderWorkOrderList()}
              {this.renderDrawer()}
            </div>
          </div>
        </div>
        <Modal
          className=''
          width={400}
          cancelText={"Cancel"}
          visible={this.state.selected_row_keys.length===0 && is_modal_visible}
          onOk={() => this.setState({ is_modal_visible: false })}
          onCancel={() => this.setState({ is_modal_visible: false })}
        >
          <h3 style={{"paddingTop": "25px", "marginBottom": "5px"}}>Update Work Order Status</h3>
          <p>{this.state.selected_row_keys.length + ' Work Order selected.'}</p>
          <div className='field-group'>
            <label style={{'color':'red'}}>Please Select any Work Order!</label>
          </div>
        </Modal>
        <Modal
          className=""
          width={400}
          okText={"Update"}
          cancelText={"Cancel"}
          visible={this.state.selected_row_keys.length>0 && is_modal_visible}
          onOk={() => this.validate()}
          onCancel={() => this.setState({ is_modal_visible: false,selected_row_keys:[],selected_work_order_status:'',time:'',selectedTechnician:'',selected_time:'',selected_date:'',errors:{} })}
        >
          <h3 style={{"paddingTop": "25px", "marginBottom": "5px"}}>Update Work Order Status</h3>
          <p>{this.state.selected_row_keys.length + ' Work Order selected.'}</p>
          <div className='field-group'>
            <label>Change Work Order Status <span className='danger'>*</span></label>
            <Select
              id={"workOrderStatus"}
              placeholder="Work Order Status"
              name="selected_work_order_status"
              onChange={(e) => {
                if (e === 'complete') {
                  this.setState(s => ({
                    ...s,
                    selected_work_order_status: e,
                    selected_time : moment("12:00 AM", ["h:mm A"])
                  }))
                } else {
                  this.setState(s => ({
                    ...s,
                    selected_work_order_status: e,
                    selected_time: '',
                    selectedTechnician: e === "forecast" ? "" : selectedTechnician
                  }))
                }
              }}              
              value={selected_work_order_status || undefined}>
              {
                workOrderStatus.WorkOrderStatus?.map((option) =>
                option?.value!=='scheduled'?
                  <Option key={option?.value} value={option?.value}>{option?.label}</Option>:null)
              }
            </Select>
            {errors?.['selected_work_order_status'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['selected_work_order_status']}</label> : ''}
          </div>
          {cond==="no" && this.state.condOne==="no"?null:<div className="field-group">
            <label>Assigned Technician</label>
            <Select
              showSearch
              placeholder="Not assigned"
              optionFilterProp="children"
              onChange={(e) => {
                this.setState({selectedTechnician:e})
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              value={selectedTechnician || undefined}
              disabled={selected_work_order_status === "forecast"}
            >
              {
                technicians?.map((technician, index) => {
                  return <Option key={index} value={technician.uuid}>{`${technician?.user?.first_name} ${technician?.user?.last_name}`}</Option>
                })
              }

            </Select>
          </div>}
          {errors?.['technician'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['technician']}</label> : ''}
          <div style={{ display: 'flex' }}>
            <div className="field-group" style={{ width: "50%", paddingRight: 5 }}>
              <label>Work Order Date<sup>*</sup></label>
              <DatePicker
                name='work-order-date'
                format="MMM DD,YYYY"
                // format="MM/DD/YYYY"
                style={{ 'width': '100%' }}
                value={selected_date ? selected_date : moment()}
                onChange={(e) => {
                  this.setState({selected_date: e});
                }}
              />
              {errors?.['selected_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['selected_date']}</label> : ''}
            </div>
            <div className="field-group" style={{ width: "50%", paddingLeft: 5 }}>
              <label>Time</label>
              <TimePicker
                className="swhite"
                placeholder={'--:-- AM/PM'}
                format={'h:mm A'}
                onChange={(e) => {
                  this.setState(s => ({ ...s, selected_time: e }))
                }}
                // defaultValue={selected_time?moment(selected_time, "h:mm A"):undefined}
                value={selected_time?moment(selected_time, "hh:mm"):undefined}
                allowClear={["forecast", "canceled"].includes(selected_time)}
                disabled={selected_work_order_status === "forecast"}
              />
              {errors?.['selected_time'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['selected_time']}</label> : ''}
            </div>
          </div>
          {errors?.['time_past'] ? <label className="new_err_msg align-items-start lh-20"><i className="las la-info-circle" />{errors?.['time_past']}</label> : ''}
          {errors?.['time_future'] ? <label className="new_err_msg align-items-start lh-20"><i className="las la-info-circle" />{errors?.['time_future']}</label> : ''}
        </Modal>
      </div>
    );
  }
}

export default ViewByWorkOrder;
